import clsx from "clsx";

import { Text, View } from "./base";
import { getGradientForName } from "../utils/gradients";

type AgentEnvironmentPillProps = {
  size?: "small" | "medium";
  variant?: "muted" | "default";
  environment: string;
  className?: string;
};

export const AgentEnvironmentPill = ({ environment, className, size = "medium", variant = "default" }: AgentEnvironmentPillProps) => {
  const gradient = getGradientForName(environment);

  return (
    <View className={clsx("flex items-center", size === "small" ? "gap-1" : "gap-2", className)}>
      <View
        className={clsx(
          "rounded-full bg-gradient-to-br flex items-center justify-center",
          gradient.from,
          gradient.to,
          gradient.darkFrom,
          gradient.darkTo,
          size === "small" ? "h-4 w-4" : "h-5 w-5",
        )}
        title={environment}
      >
        <Text className={clsx("font-bold text-white", size === "small" ? "text-[0.5rem]" : "text-xs")}>{environment.substring(0, 1).toUpperCase()}</Text>
      </View>
      <Text className={clsx("font-medium", size === "small" ? "text-xs" : "text-sm", variant === "muted" && "!text-gray-700 dark:!text-gray-400")}>
        {environment}
      </Text>
    </View>
  );
};
